import React from 'react';
import PropTypes from 'prop-types';

import TextSmall from '../TextSmall';

import {
  OverBoxEmployee,
  OverBoxEmployeeEmpty,
  BoxHobbie,
  ItemHobbie,
  TitleHobbie,
  StyleEditIcon
} from './style';

import { Pencil } from '../../../../assets/images/index';

const Resume = (dataHobbies, limit) =>
  dataHobbies.slice(0, limit).map(item => (
    <ItemHobbie key={item.hobbyId}>
      <TitleHobbie>{`${item.hobbyCat} - ${item.hobby}`}</TitleHobbie>
    </ItemHobbie>
  ));

const HobbieUser = ({
  className,
  dataHobbies,
  limit,
  onEditMode,
  clickEditIcon
}) =>
  dataHobbies && dataHobbies.length !== 0 ? (
    <OverBoxEmployee
      className={className}
      title="Hobbies"
      more={dataHobbies && dataHobbies.length > limit}
      moreInfo={Resume(dataHobbies, dataHobbies.length || 0)}
    >
      <BoxHobbie>
        {onEditMode && (
          <StyleEditIcon
            svg={Pencil}
            size="m"
            color="dark"
            onClick={clickEditIcon}
            hover
          />
        )}
        {Resume(dataHobbies, limit)}
      </BoxHobbie>
    </OverBoxEmployee>
  ) : (
    <OverBoxEmployeeEmpty className={className} title="Hobbies">
      <BoxHobbie>
        {onEditMode && (
          <StyleEditIcon
            svg={Pencil}
            size="m"
            color="dark"
            onClick={clickEditIcon}
            hover
          />
        )}
        <TextSmall>Parece que aún no hay hobbies para mostrar.</TextSmall>
      </BoxHobbie>
    </OverBoxEmployeeEmpty>
  );

HobbieUser.propTypes = {
  className: PropTypes.string,
  dataHobbies: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      HobbieLevel: PropTypes.string
    })
  ),
  limit: PropTypes.number,
  onEditMode: PropTypes.bool,
  clickEditIcon: PropTypes.func
};

export default HobbieUser;
